import api from '../api'

function secondTags(second_tags) {
  let secondTagStr = ''
  second_tags &&
    second_tags.forEach(tag => {
      secondTagStr += `<a target="_blank" href="${api.host}/qa/tag_${tag['id']}">
        #${tag['name']}
      </a>
    `
    })
  return secondTagStr
}

function branchMark(branchId, branchName) {
  let branchMark = ''
  if (branchId && branchName) {
    branchMark = `<a target="_blank" class="branch-mark" href="${api.host}/qa/cantonal/cantonal-index?cantonal_id=${branchId}">
      #来自『${branchName}』
    </a>`
  }
  return branchMark
}

function questionReward(info, sshzv, paidQa) {
  let questionReward = ''
  if (paidQa) {
    questionReward = '<span>付费问答</span>'
  } else {
    let question_reward = info['question_reward']
    if (!sshzv) {
      if (+info['quality_tag_id'] === 4) {
        questionReward = '<span class="crisis">危机</span>'
      } else if (question_reward && question_reward.question_id) {
        questionReward = '<span>悬赏</span>'
      }
    }
  }
  return questionReward
}

function filterBr(content) {
  return (content + '').replace(/\s*/g, '').replace(/(<br>){2,}/g, '<br>')
}

module.exports = function(data, sshzv, isZero = false) {
  let questionList = ''
  data.forEach(item => {
    let paidQa = item.object_type === 'psychic_coach_pay'
    let undeblock = item.is_exchange === 0
    let href = paidQa
      ? `${api.static}/msite/index.html#/heart-search/paid-qa-${
          undeblock ? 'deblock' : 'detail'
        }/${item['id']}?hideNavigationBar=${undeblock ? '0' : '1'}`
      : `${api.host}/qa/${item['id']}`
    questionList += `
      <li class="recommend-content${paidQa ? ' paidQa' : ''}">
          <div class="tag">
            ${secondTags(item['second_tags'])}
            ${branchMark(item['cantonal_id'], item['cantonal_name'])}
          </div>

          <div class="author new-author">
            <div class="author-title">
              <a target="_blank" href="${href}">
                <p class="question-title">
                  ${item['major_title'] ? item['major_title'] : item['title']}
                  ${
                    item['show_start']
                      ? '<img class="start" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAAAXNSR0IArs4c6QAAAz5JREFUWAntVk9IFFEY/74ZW9GCokt0kQQXqehgt/7QISkIwk5BoasS9OcSEe26Bh32UOGOG1YEgYWomx0Mog5FdDCwDkG3SCIMKvTiKSktbJv5+t6sM+zMvpl94ixdfDA7731/ft/vfe973yzA2vhPGaBU1z7xBIWvCVJELzd7ljGPybBRJoxaRj2J7WBZUzaupu1EI//RH0PzC6qytijFuGLTCMV5WZiqZ4R6u7eBWfgEBDE7OsIf0Nc1Y9/w11I2VSNCVxKNsGRdYgKnOGBdaVCe/+bcDEGtdgOv5r8IXeREqLezBf5aXJh0nPF1ESRkmEzhEdRohnKN0Pi4Tql2sbvwYVITk4izUSUSAodt2JZ9lDNCqY6TQHQHtmgNmMovhrNh+N7EQQ6QZp/DUlvEl6BjFvvyE0Kv3kcIROVvhjnrNL9vCuewsRxggtKd+8E0J9nW2TSBrh/A7OibUn+lo6GejkO8xxbbEfEiZTLKG7ADIj51g/LcT0LolIhw5addIKIGWJg+4a5VJkhZ16x07goViHBt7OZzbi3xEUl22rVHHLRAY+wtIL4Wjz2XGCpkhMqDEuzisz8iwQsRaQbvmx/5cApIqqXL7TugAO9ZWX4VxQ6b6lvx7GBB6uwTEpEdCxHJp7KXUiJFApgEpHa3NUu9cZb1A6DF7qEx9FNmoirzELH/L5DJhUlHGcCjCwfEefa5C7G6W3j9/ly4rVyLdspSXW0AdlveKzdTleIS0x/h9pTD/uFpVS9hh3wrkryba6FHsBLEou03Lqs2zI2K+lIaGvY/yAHWNjKnfn5+KHkFGuEHvqJdEF8fXwkJAeepA0qf2Qj06xxYcIGztDUwXrlikr8bBvTlnwfdinIXr8RDxFHR7fO1MPM9weskN7NmR+57E+/+CR+uEdSkfPahSykRx4My3ZtgoTDD6w2OzH0jjvGxdrjrVU5COytmhudBw0FpDAruklL7CsJQIkVfGuBS8nZPxBcrLcYKPCp/ffn8ZxnkoQcIo82GwFbICFvpOl9t7jT2wHdojL4qzqP7VSKC2ZEpvujP7LAaBX5BV0NLiUgxAPcJwM9QH3+8moCR+FKyc08kQGsgChn4Bwfc7n1o08NEAAAAAElFTkSuQmCC" alt="">'
                      : ''
                  }
                  ${questionReward(item, sshzv, paidQa)}
                </p>
              </a>
            </div>
          </div>

          <div class="ask">
            <div class="ask-detail hide-content" href="${href}">
              ${filterBr(item['content'])}
            </div>
            <div class="switch" data-tab="ques">...全文</div>
            <div class="arrow">收起</div>
          </div>
          ${
            paidQa
              ? ''
              : `
            <div class="ques-btn">
              <div class="ques-btn-answer">
                <a target="_blank" href="${api.host}/qa/${item['id']}">
                  <span>${isZero ? '抢首答' : '写个回答'}</span>
                </a>
              </div>
              <div class="ques-btn-feel" data-question_id="${
                item['id']
              }" data-tab="ques">
                <p class="${
                  +item['is_same_feeling'] ? 'has-feel' : ''
                }">有同感&nbsp;<span class="number">${
                  item['same_feeling_num']
                }</span></p>
              </div>
              <div class="ques-btn-invite" data-question_id="${item['id']}">
                <span>还能邀答（<span class="time">${
                  item['int_invite_number']
                }</span>次）</span>
              </div>
            </div>
          `
          }
          
      </li>
    `
  })
  return questionList
}



// WEBPACK FOOTER //
// ./src/pages/ask/askIndex/render/questionList.js